function checkHasPaidTicketTypes({ pageTicketGroups }) {
  return pageTicketGroups.some(pageTicketGroup => {
    return pageTicketGroup.ticketTypes.some(
      ticketType => ticketType.price > 0 || ticketType.pricing === 'pwyw',
    );
  });
}

export default function checkIsFreeEvent({ pageTicketGroups }) {
  // check if any of the ticket types have a price
  const hasPaidTicketTypes = checkHasPaidTicketTypes({
    pageTicketGroups,
  });

  return !hasPaidTicketTypes;
}
